import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

// The following imports will be necessary when used in Pages
// import { RemoteMarkdown } from '@piconetworks/pkg-remote-markdown'
// import styles from './Text.module.scss'

var isBlankDraftJs = function isBlankDraftJs(draftJsValue) {
  var isBlank = (!(draftJsValue !== null && draftJsValue !== void 0 && draftJsValue.blocks.length) || (draftJsValue === null || draftJsValue === void 0 ? void 0 : draftJsValue.blocks.length) === 1 && !draftJsValue.blocks[0].text) && isEmpty(draftJsValue === null || draftJsValue === void 0 ? void 0 : draftJsValue.entityMap);
  return isBlank;
};

// eslint-disable-next-line no-unused-vars
var TextPreview = function TextPreview(_ref) {
  var draftJsValue = _ref.draftJsValue,
    getCustomText = _ref.getCustomText;
    _ref.url;
  var isBlank = isBlankDraftJs(draftJsValue);
  if (isBlank) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, getCustomText(draftJsValue));
};
TextPreview.propTypes = {
  draftJsValue: PropTypes.object,
  getCustomText: PropTypes.func,
  html: PropTypes.string,
  url: PropTypes.string
};
var TextPreview$1 = /*#__PURE__*/React.memo(TextPreview);

export { TextPreview$1 as default, isBlankDraftJs };
//# sourceMappingURL=index.js.map
